module.exports = __webpack_public_path__ + "static/media/6.553b2348.jpg";